
// Prevent focusout inside fit device.
// Prevent mouseleave if target is inside fit device.


(function($) {

    $(document).ready(function() {
        var $navbar = $('#main-nav'),
            $menuToggler = $navbar.find('.menu-toggler'),
            $mainMenu = $navbar.find('ul.main-menu');

        // Toggle menu
        $menuToggler.click(toggleMenuClick)

        // Close all
        $navbar.find('.navbar-backdrop').click(function() {
            resetMenu();
            return false;
        })

        // Close menu
        $navbar.find('.submenu-close').click(function(e) {
            if (isMobileMenuOpen()) {
                var $menuItem = $(this).parent().find('.menu-item.sfHover');

                if ($menuItem.length) {
                    // Remove works on first, second and last
                    $menuItem = $menuItem.filter(function(){
                        return $(this).parent().is(":not(.submenu-third):not(.submenu-fourth)");
                    });

                    // Close from deepest point
                    $menuItem = $menuItem.last();
                }

                if (!$menuItem.length) {
                    // Close parent
                    $menuItem = $(this).closest('.menu-item')
                }

                if ($menuItem.length) {
                    $menuItem.superfish('hide')
                }
            }
        })

        // Escape close menu
        $(document).keyup(function(e) {
            if (e.keyCode === 27 && isMobileMenuOpen()) {
                $menuToggler.addClass('collapsed');
                toggleMenuClick();
            }
        });

        // Desktop
        if (!$menuToggler.is(':visible')) {
            initDropdownMenu();
        }

        //Mobile translateX
            $('.submenu-link:not(.submenu-second-link)').click(function(link){
                $(".main-menu").animate({left: "-=100%"})
            });

            $('.submenu-close').click(function(){
                $(".main-menu").animate({left: "+=100%"})
            });
            $('.menu-toggler').click(function(){$(".main-menu").css({left: "0"})});

        /**
         * Init menu
         */
        function initDropdownMenu() {

            var options = {
                delay: 400,
                speed: 1,
                speedOut: 300,
                cssArrows: false,
                disableHover: isMobileMenuOpen() ? true : false,
                pathLevels: 0,
                //pathClass: 'active',
                popUpSelector: '.submenu',
                touchHandleSelector: '.submenu-link',
                excludeSelector: '.submenu-title',
                onHandleTouch: function () {
                    var $submenu = $(this);

                    initSubmenuHandlers($submenu);

                },
                onBeforeShow: function(reference) {
                    var $submenu = $(this);

                    if ($submenu.length) {
                        // Trigger inview manually
                        if ($submenu.hasClass('submenu-fifth')) {
                            //$submenu.find('img.lazy').trigger('inview');
                        }

                        // Prevent double events firing for focus and click
                        if ($submenu.parent().hasClass('sfHover')) {
                            // Toggle menu display
                            //$submenu.hide();
                            //$submenu.parent().removeClass('sfHover');

                            //return false;
                        }
                    }
                },
                onShow: function() {
                    var $submenu = $(this);

                    if ($submenu.length) {
                        var $firstSubmenu = $submenu.hasClass('submenu-first') ? $submenu : $submenu.closest('.submenu-first');

                        // Clean up other top level menus e.g switch between mega menu and open 'fit my device'
                        if ($submenu.hasClass('submenu-first')) {
                            var $openSiblingMenus = $submenu.parent().siblings().find('.remain-open');
                            if ($openSiblingMenus.length) {
                                $openSiblingMenus.removeClass('remain-open');
                                $navbar.removeClass('remain-open')
                            }
                        }
                        if (!isMobileMenuOpen()) {

                            // Setup top level
                            if ($firstSubmenu.find('> .sfHover').length == 0) {
                                // First search direct active page
                                var $activeMenuItem = $firstSubmenu.find('.submenu-item.active').first();
                                var $defaultFirst;

                                if ($activeMenuItem.length) {
                                    // Traverse up till top level
                                    $defaultFirst = $activeMenuItem.parentsUntil('.submenu-first');
                                    if ($defaultFirst) {
                                        $defaultFirst.last()
                                    }
                                }

                                // Else search .active-parent
                                if (!$defaultFirst || $defaultFirst.length == 0) {
                                    $activeMenuItem = $firstSubmenu.find('.submenu-item.active-parent').last();

                                    if ($activeMenuItem && $activeMenuItem.length) {
                                        // Active page setup parent encase parent pages not exact
                                        $defaultFirst = $activeMenuItem.parentsUntil('.submenu-first').last();
                                    }
                                }

                                // Default if empty or not hightlighted e.g 'all products'
                                if (!$defaultFirst || !$defaultFirst.hasClass('menu-item')) {
                                    $defaultFirst = $firstSubmenu.find('> .menu-item:eq(0)');
                                }

                                //display first of each submenu item
                                if(!$defaultFirst.prevObject.hasOwnProperty('prevObject')){
                                    $('.submenu-first-item').first().addClass('sfHover');
                                    $('.submenu-second-item').first().addClass('sfHover');
                                    $('.submenu-second').first().attr('style', 'display: block');
                                    $('.submenu-preview').first().attr('style', 'display: block');
                                }

                                // finally trigger superfish
                                if ($defaultFirst.length) {
                                    $('.submenu-first-item').first().removeClass('sfHover');
                                    $('.submenu-second-item').first().removeClass('sfHover');
                                    $defaultFirst.superfish('show'); // .trigger('focusin.superfish');
                                }
                            }
                        }

                        if ($submenu.hasClass('submenu-second')) {
                            // Cleanup active siblings
                            $submenu.parent().siblings('.sfHover').not($submenu.parent()).removeClass('sfHover');

                            // Clean up
                            $submenu.find('.remain-open').removeClass('remain-open');

                            // Showing second menu add group state
                            $submenu.closest('.submenu-first').filter(':not(.sfGroupActive)').addClass('sfGroupActive');

                            // // Show third/fourth
                            $submenu.find('.submenu-second, .submenu-third, .submenu-fourth').each(function(i) {
                                if (i === 0){
                                    $(this).parent().superfish('show')
                                    return false;
                                }
                            });
                        }

                        initSubmenuHandlers($submenu);

                        submenuContent($submenu);

                        // Scroll top
                        $submenu.filter('.submenu-second').scrollTop(0);
                    }
                },
                onBeforeHide: function(instant) {
                    var $submenu = $(this);

                    // Remain open from click
                    if ($submenu.hasClass('remain-open')) {
                        $submenu.filter('.remain-open').each(function() {
                            $(this).parent().superfish('show')
                        });
                        $navbar.addClass('remain-open')
                        return false;
                    }
                },
                onHide: function () {
                    var $submenu = $(this);

                    if ($submenu.length) {
                        $submenu.parent('.sfClick').removeClass('sfClick')

                        if (!$submenu.parent().siblings().add(this).hasClass('sfHover')) {
                            if ($submenu.hasClass('submenu-first') || $submenu.hasClass('submenu-second')) {
                                $submenu.removeClass('sfGroupActive')
                                $submenu.closest('.sfGroupActive').removeClass('sfGroupActive')
                            }
                        }

                        // Prevent closing second level desktop when mega menu active.
                        if (!isMobileMenuOpen()) {
                            if ($submenu.hasClass('submenu-second') && $submenu.closest('.mega-menu').hasClass('sfHover')) {
                                if ($submenu.parent().siblings('.sfHover').length == 0) {
                                    $submenu.parent().addClass('sfHover');
                                }
                            }
                        }

                    }

                    //display first of each submenu item
                    // $('.submenu-first-item').first().addClass('sfHover');
                    // $('.submenu-second-item').first().addClass('sfHover');
                    // $('.submenu-second').first().attr('style', 'display: block');
                    // $('.submenu-preview').first().attr('style', 'display: block');

                }
            }; // end superfish

            // Setup dropdown
            $mainMenu.superfish(options);

            //display first of each submenu item
            $('.submenu-first-item').first().addClass('sfHover');
            $('.submenu-second-item').first().addClass('sfHover');
            $('.submenu-second').first().attr('style', 'display: block');
            $('.submenu-preview').first().attr('style', 'display: block');
        }

        /**
         * Used to detect if mobile
         * @returns {*|boolean}
         */
        function isMobileMenuOpen() {
            return $menuToggler.is(':visible') && !$menuToggler.hasClass('collapsed');
        }

        function resetMenu() {
            $navbar.removeClass('remain-open');

            //$mainMenu.superfish('destroy');
            //$mainMenu.find('.submenu').superfish('hide');

            // CLEANUP
            const classNames = ["remain-open", "sfGroupActive", "sfHover", "sfClick"]
            classNames.forEach(function (className) {
                $mainMenu.find('.' + className).removeClass(className);
            });

            $mainMenu.find('.submenu:visible').hide();
        }

        /**
         * Toggle Mobile menu collapser
         */
        function toggleMenuClick() {
            resetMenu();

            var hoverEnabled = false;

            // Disable hover
            if (!$menuToggler.hasClass('collapsed')) {
                //hide
            } else {
                // Destroy if change IE desktop to mobile.
                if ($.fn.superfish.defaults.hoverEnabled != hoverEnabled) {
                    $mainMenu.superfish('destroy');
                    $.fn.superfish.defaults.hoverEnabled = hoverEnabled;
                }
            }

            initDropdownMenu();
        }

        /**
         * Setup menu click event handlers once
         * @param $submenu
         */
        function initSubmenuHandlers($submenu) {
            if ($submenu.data('megamenu-handler')) return;

            $submenu.find('.menu-item:not(".submenu-first-item") > .menu-link').on('click.submenu', function(e) {
                var href = $(this).attr('href');

                // Custom click for grid menu
                if ($submenu.hasClass('submenu-fourth')) {
                    var $submenuGrid = $(this).parent().find('> .submenu-fifth');
                    showMegaMenuGrid($submenuGrid);
                }

                // Prevent default if null link OR has submenu
                var $sub2menu = $(this).next('.submenu')
                if (href == '' || href == '#' || ($sub2menu.length && ($sub2menu.hasClass('submenu-fifth') || !$sub2menu.is(':visible')))) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    e.preventDefault();
                } else {
                    window.location = href;
                }

                //On mobile

                return false;
            })

            // Finder focus prevent close
            /*if ($submenu.parent().hasClass('menu-full')) {
                $submenu.on('click', function() {
                    $submenu.addClass('remain-open');
                })
                $navbar.addClass('remain-open')
            }*/

            $submenu.data('megamenu-handler', true);
        }

        /**
         * Set menu bdoy content
         * @param $submenu
         */
        function submenuContent($submenu) {
            // Dynamically load scripts when needed.
            var $scripts = $submenu.find('script[type=\'text/plain\']');
            $scripts.each(function(){
                var $script = $(this);
                $.getScript($script.attr('src'), function () {
                    $script.remove();

                    // Finder input changed keep submenu open
                    $('#scanstrut-finder').on('change.submenu', ':input', function() {
                        $navbar.addClass('remain-open')
                        $submenu.addClass('remain-open')
                    })
                });
            })
        }

        /**
         *
         * @param $submenu
         * @returns {boolean}
         */
        function showMegaMenuGrid($submenu) {
            $submenu.find('img.lazy').trigger('inview');

            // Open this
            $submenu.parent().addClass('sfClick');
            $submenu.superfish('show');

            var html = '';
            // Reverse ordering of parents for breadcrumb
            var $parents = $($submenu.parents('.menu-item').get().reverse());
            $parents.each(function () {
                if ($(this).parent().hasClass('main-menu')) return true;
                var $link = $(this).find('> .menu-link');
                html += '<li><a class="grid-link" href="' + $link.attr('href') + '">' + $link.text() + '</a></li>'
            })

            $submenu.find('.submenu-breadcrumb > ul').html(html)

            // Breadcrumbs/products click
            $submenu.find('.grid-link').on('click.submenu', function(e) {
                window.location = $(this).attr('href');
                return false;
            })

            return false;
        }
    });


})(jQuery);

